import { postRequest } from "./requests";
import { endpoints } from "./urls";

const {
	submitForm,
	userCreation,
	otpValidation,
	resendOtpCode,
	login,
	forgotPassword,
	changePassword,
	verifyContactInfo,
} = endpoints;

const submitFormData = (rData) =>
    postRequest(submitForm, rData, { resourceName: "submitForm" });

const createUser = (rData) =>
    postRequest(userCreation, rData, { resourceName: "userCreation" });

const validateOtp = (rData) =>
    postRequest(otpValidation, rData, { resourceName: "otpValidation" });

const resendOtp = (rData) =>
    postRequest(resendOtpCode, rData, { resourceName: "resendOtpCode" });

const loginUser = (rData) =>
    postRequest(login, rData, { resourceName: "login" });

const forgotPasswordUser = (rData) =>
    postRequest(forgotPassword, rData, { resourceName: "forgotPassword" });

const changePasswordUser = (rData) =>
    postRequest(changePassword, rData, { resourceName: "changePassword" });

const validateEmailCelphone = (rData) =>
    postRequest(verifyContactInfo, rData, { resourceName: "verifyContactInfo" });

export {
	submitFormData,
	createUser,
	validateOtp,
	resendOtp,
	loginUser,
	forgotPasswordUser,
	changePasswordUser,
	validateEmailCelphone,
};
